import queryLogout from "@/services/logout"

const useFetchLogout = () => {
  const { resetPlayerInfo, resetCertification } = useAuthStore()
  const { handler } = queryLogout
  const fetchLogout = async () => {
    try {
      await handler()
      resetPlayerInfo()
      resetCertification()

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  return { fetchLogout }
}

export default useFetchLogout
